// Browser side of the H1 title fallback (build side: scripts/apply-h1-title-fallback.js).
//
// Gatsby renders <Head> into a hidden root asynchronously and then swaps the
// nodes into <head>, on hydration and on every client-side navigation. That
// puts the generic site title back, so we watch <head> and re-apply the H1
// whenever a tag marked by the SEO component appears.

const FALLBACK_SELECTOR = "[data-title-fallback]";

const getH1Text = () => {
  const h1 = document.querySelector("h1");
  return h1 ? h1.textContent.replace(/\s+/g, " ").trim() : "";
};

export const applyH1TitleFallback = () => {
  const nodes = document.head.querySelectorAll(FALLBACK_SELECTOR);
  if (!nodes.length) return;

  const text = getH1Text();
  if (!text) return;

  nodes.forEach((node) => {
    if (node.tagName === "TITLE") {
      if (node.textContent !== text) node.textContent = text;
    } else if (node.getAttribute("content") !== text) {
      node.setAttribute("content", text);
    }
  });
};

export const observeHeadForTitleFallback = () => {
  if (typeof MutationObserver === "undefined") return;
  // childList on <head> only: our own edits change the title's text node, not
  // <head>'s children, so they don't re-trigger the observer.
  new MutationObserver(applyH1TitleFallback).observe(document.head, {
    childList: true,
  });
  applyH1TitleFallback();
};
